import Vue from 'vue';

import AjaxPlugin from 'vux/src/plugins/ajax/index.js'


import baseURL from './config';

import Form from './form';

import { env } from '../../utils/Env';

Vue.use(AjaxPlugin);

const getUrlParam = (url, param) => {
const { search, href } = window.location;
let searchBody = '';
if (url && url.split('?').length > 1) {
searchBody = url.split('?')[1];
} else if (search) {
searchBody = search.replace('?', '');
} else if (href && href.split('?').length > 1) {
searchBody = href.split('?')[1];
}
if (!searchBody) return null;
searchBody = decodeURIComponent(searchBody);
const searchList = searchBody.split('&');
const map = {};
searchList.forEach((item) => {
const index = item.indexOf('=');
const key = item.substr(0, index);
const value = item.substr(index + 1, item.length);
map[key] = decodeURIComponent(value);
});
return param ? map[param] : map;
};

const getHeader = () => {
const map = getUrlParam();
if (!map) return;

const header = {
env: env.name,
userid: map.userId,
deviceid: map.deviceId,
token: map.token,
ws_wxapp_ver: map.version,
pkg_version: map.pkg_version,
};
return header;
};

const Ax = Vue.http.create({
baseURL,

timeout: 1024000,
withCredentials: true,



});


Ax.interceptors.response.use(response => response, (error) => {
const response = error.response;
if (response.status === 401) {
return Promise.reject('login failed');
}
if (response.status === 404) {
return Promise.reject({
status: 404,
});
}
return Promise.reject(error);
});

const myPromise = {
then() {
return myPromise;
},
catch() {
return myPromise;
},
};

const Request = {
get(url, data = {}, headers = {}) {
return new Promise((resolve, reject) => {
Ax.get(url, {
params: data,
headers,
}).then((res) => {
resolve(res.data);
}).catch((err) => {
reject(err);
});
});
},
post(url, data = {}, config) {
return new Promise((resolve, reject) => {
Ax.post(url, { ...data }, config).then((res) => {
resolve(res.data);
}).catch((err) => {
const msg = err.message || '接口错误';
reject(msg);
});
});
},
form: Form.form,
getHeader,
getUrlParam,
};

export default Request;



// WEBPACK FOOTER //
// ./src/utils/Request/index.js